import { render } from "./SistemiPanel.vue?vue&type=template&id=414905de&scoped=true"
import script from "./SistemiPanel.vue?vue&type=script&lang=js"
export * from "./SistemiPanel.vue?vue&type=script&lang=js"

import "./SistemiPanel.vue?vue&type=style&index=0&id=414905de&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-414905de"]])

export default __exports__